// Traduit les tailles stockées en base (FR) vers la langue courante.
export const sizeLabel = (s, t) => {
  if (!s) return "";
  if (s === "Sur-Mesure") return t("sizes.custom");
  if (s === "Unique") return t("sizes.onesize");
  const m = s.match(/^(\d+)\s*ans$/i);
  if (m) return t("sizes.years", { n: m[1] });
  return s;
};
